<template>
  <div class="dashboard-notification" v-if="showNotification && statusNotificationMessage" :class="`dashboard-notification--${statusNotificationMessage.type}`">
    <div class="pa-1 text--center">
      {{ statusNotificationMessage.text }}
      <div class="d-flex align-center justify-center">
        <v-button
          size="small"
          v-if="hasNoDocuments"
          class="mt-1 text--center"
          @click="showProfileDocuments()"
        >
          {{ $t('components.DashboardNotification.uploadDocuments') }}
        </v-button>

        <v-button
          size="small"
          v-if="profile.status === 'DEACTIVATED'"
          class="mt-1 text--center"
          @click="$router.push({ name: 'settlements' })"
        >
          {{ $t('components.DashboardNotification.fillUpTheBalance') }}
        </v-button>
<!--        <v-button size="small" class="mt-1 text&#45;&#45;center" @click="showProfile = true">Fill up the balance</v-button>-->
<!--        <v-button size="small" class="mt-1 text&#45;&#45;center" @click="showProfile = true">Fill up the balance</v-button>-->
      </div>
    </div>

    <profile v-model="showProfile" :profile-prop="profile" :default-section="defaultProfileSection"></profile>
  </div>
</template>

<script>
import vButton from '@/ui/controls/vButton'

import Profile from '@/components/Profile'

import setClassModifiers from '@/mixins/setClassModifiers'
import statusNotificationMessage from '@/mixins/statusNotificationMessage'
import profile from '@/mixins/profile'

export default {
  props: {
    type: {
      type: String,
      default: 'warning'
    }
  },

  mixins: [setClassModifiers, profile, statusNotificationMessage],

  components: {
    vButton,
    Profile
  },

  methods: {
    showProfileDocuments () {
      this.showProfile = true
      this.defaultProfileSection = 'documentSection'

      setTimeout(() => { this.defaultProfileSection = null }, 1500)
    }
  },

  data () {
    return {
      showProfile: false,
      defaultProfileSection: null
    }
  },

  computed: {
    hasNoDocuments () {
      const profile = this.profile
      const status = profile.status
      const documentList = profile.documentList ? profile.documentList.filter(item => item.documentCode.match(new RegExp('OOO_|IP_', 'gi')) && item.file) : []
      const hasDocuments = documentList.length <= 0

      return hasDocuments && status && !status.match(/READY|VERIFICATION|DEACTIVATED/)
    },

    showNotification () {
      const profile = this.profile
      const status = profile.status
      const isActive = profile.active && true

      return status === 'NEW' ||
        // status === 'READY' ||
        status === 'VERIFICATION' ||
        status === 'CORRECTION' ||
        status === 'OUT_PLATFORM' ||
        status === 'DEACTIVATED' ||
        this.hasNoDocuments ||
        !isActive
    }
  }
}
</script>

<style lang="scss">
.dashboard-notification {
  border-radius: $border-radius;
  border: 2px solid lighten($color-yellow, 15);
  background-color: lighten($color-yellow, 35);

  &--error {
    border: 2px solid $color-red-light;
    background-color: lighten($color-red-light, 13);
  }

  &--success {
    border: 2px solid $color-green-lighten;
    background-color: lighten($color-green-lighten, 12);
  }
}
</style>
